import { render, staticRenderFns } from "./profile-icon.vue?vue&type=template&id=f442d5a4"
import script from "./profile-icon.vue?vue&type=script&lang=js"
export * from "./profile-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports